// 空数据组件
<template>
  <div class="none-container">
    <img :src="nonePng" class="none">
  </div>
</template>

<script>
import nonePng from "../assets/none2.png"
export default {
  name:"none",
  data(){
    return {
      nonePng,
    }
  }
}
</script>


<style lang="less" scoped>
.none-container{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  // background-color: #f5f5f5;
  position:relative;
  top:-35px;
  left: 0;
  .none{
    width: 180px;
    height: 180px;
  }
}
</style>